import React, { useMemo } from 'react';

interface IWidgetComponentContextValue {
  name?: string;
  preview?: boolean;
  /**
   * Specifica se il widget è in sola lettura a livello di singolo widget, nello
   * specifico serve per le Integrazioni dove _alcuni_ campi non sono
   * modificabili.
   * Questo a livello di UI si traduce in campi _disabilitati_ (disabled).
   */
  isOnlyWidgetReadonly?: boolean;
}

/**
 * Context (wip) per gestire le opzioni di un Widget e passarle ai
 * componenti interni.
 * TODO Nasce per gestire il preview di un widget, ma dovrebbe essere
 * utilizzato anche per gestire le opzioni di un widget in generale (es.
 * getParsedOptions), o per lo `Scope`.
 */
export const WidgetComponentContext =
  React.createContext<IWidgetComponentContextValue>({
    name: '',
    preview: false,
  });

export interface IWidgetComponentContextProviderProps {
  name?: string;
  preview?: boolean;
  isOnlyWidgetReadonly?: boolean;
  children: React.ReactNode;
}

export function WidgetComponentContextProvider(
  props: IWidgetComponentContextProviderProps,
) {
  const { name, preview, isOnlyWidgetReadonly } = props;
  const value = useMemo(
    () => ({ name, preview, isOnlyWidgetReadonly }),
    [name, preview, isOnlyWidgetReadonly],
  );

  return (
    <WidgetComponentContext.Provider value={value}>
      {props.children}
    </WidgetComponentContext.Provider>
  );
}

// Si potrebbe rinominare in `useWidgetComponentOptions`
export const useWidgetComponentContext = () => {
  return React.useContext(WidgetComponentContext);
};
